/**
 * CoFiTo — Scroll Scrub + Reveal
 * Video del hero controlado por scroll con lerp suave.
 */
(function () {
  'use strict';

  var KNOWN_DURATION = 3.083; // duración exacta del video 0411

  /* ─────────────────────────────────────────────
     1. SCROLL SCRUB
  ───────────────────────────────────────────── */
  function initScrollScrub() {
    var videoUrl = window.cofitoHeroVideoUrl;
    if (!videoUrl) return;

    var heroSection = document.querySelector('.shopify-section.hero-wrapper');
    if (!heroSection) {
      var all = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < all.length; i++) {
        if (all[i].querySelector('.hero')) { heroSection = all[i]; break; }
      }
    }
    if (!heroSection) return;

    var heroEl = heroSection.querySelector('.hero') || heroSection;

    // PASO 1: Crear wrapper PRIMERO (DOM estable)
    var scrollVh = Math.round(KNOWN_DURATION * 200); // 200vh/s → ~617vh
    var wrapper = document.createElement('div');
    wrapper.className = 'cofito-scrub-wrapper';
    wrapper.style.setProperty('--scrub-height', scrollVh + 'vh');
    heroSection.parentNode.insertBefore(wrapper, heroSection);
    wrapper.appendChild(heroSection);

    // PASO 2: Barra de progreso
    var bar = document.createElement('div');
    bar.className = 'cofito-scrub-bar';
    bar.innerHTML = '<div class="cofito-scrub-bar__fill"></div>';
    document.body.appendChild(bar);
    var fill = bar.querySelector('.cofito-scrub-bar__fill');

    // PASO 3: Scroll cue
    initScrollCue(heroEl);

    // PASO 4: Inyectar video dentro de .hero__media-grid (reemplaza SVG placeholder)
    var mediaGrid = heroEl.querySelector('.hero__media-grid');
    var svg = mediaGrid && mediaGrid.querySelector('svg');
    if (svg) svg.remove();

    var video = document.createElement('video');
    video.setAttribute('data-cofito-scrub', 'true');
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'auto';
    video.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:0;pointer-events:none;display:block;';

    if (mediaGrid) {
      mediaGrid.insertBefore(video, mediaGrid.firstChild);
    } else {
      video.style.zIndex = '2';
      if (getComputedStyle(heroEl).position === 'static') heroEl.style.position = 'relative';
      heroEl.insertBefore(video, heroEl.firstChild);
    }

    // PASO 5: Lerp state
    var targetProgress = 0;
    var currentProgress = 0;
    var rafId = null;

    function lerp(a, b, t) { return a + (b - a) * t; }

    function renderLoop() {
      var diff = targetProgress - currentProgress;

      if (Math.abs(diff) > 0.0005) {
        currentProgress = lerp(currentProgress, targetProgress, 0.12);
        var t = currentProgress * KNOWN_DURATION;

        if (video.readyState >= 1) {
          if (video.fastSeek) {
            video.fastSeek(t);
          } else {
            video.currentTime = t;
          }
        }

        fill.style.transform = 'scaleX(' + currentProgress + ')';
      }

      rafId = requestAnimationFrame(renderLoop);
    }

    // PASO 6: Scroll listener — solo actualiza targetProgress
    window.addEventListener('scroll', function () {
      var rect = wrapper.getBoundingClientRect();
      var scrollable = wrapper.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return;

      targetProgress = Math.max(0, Math.min(1, -rect.top / scrollable));

      // Header: transparente mientras el scrub está en pantalla
      var pastScrub = rect.bottom <= window.innerHeight;
      document.body.classList.toggle('cofito-scrubbing', !pastScrub);
    }, { passive: true });

    // Iniciar render loop
    renderLoop();

    // Activar scrubbing al inicio
    document.body.classList.add('cofito-scrubbing');

    // PASO 7: Cargar video via fetch+blob (dom ya estable)
    setTimeout(function () {
      fetch(videoUrl)
        .then(function(r) { return r.blob(); })
        .then(function(blob) {
          video.src = URL.createObjectURL(blob);
          video.load();
        })
        .catch(function() {
          video.src = videoUrl;
          video.load();
        });

      function unlockSeeking() {
        var p = video.play();
        if (p && p.then) {
          p.then(function() { video.pause(); video.currentTime = 0; })
           .catch(function() { video.currentTime = 0; });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
      video.addEventListener('canplay', unlockSeeking, { once: true });
    }, 50);
  }

  /* ─────────────────────────────────────────────
     2. SCROLL CUE
  ───────────────────────────────────────────── */
  function initScrollCue(target) {
    if (!target || target.querySelector('.cofito-scroll-cue')) return;
    if (getComputedStyle(target).position === 'static') target.style.position = 'relative';

    var cue = document.createElement('div');
    cue.className = 'cofito-scroll-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.innerHTML = '<span class="cofito-scroll-cue__label">scroll</span><div class="cofito-scroll-cue__arrow"></div><div class="cofito-scroll-cue__arrow"></div>';
    target.appendChild(cue);

    window.addEventListener('scroll', function () {
      cue.classList.toggle('is-hidden', window.scrollY > window.innerHeight * 0.15);
    }, { passive: true });
  }

  /* ─────────────────────────────────────────────
     3. SECTION REVEAL
  ───────────────────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.shopify-section').forEach(function(el) { el.classList.add('cofito-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('cofito-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.shopify-section').forEach(function(section) {
      if ((section.id && section.id.includes('header')) || section.classList.contains('hero-wrapper')) {
        section.classList.add('cofito-visible');
        return;
      }
      observer.observe(section);
    });
  }

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  function init() {
    initScrollScrub();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
